export default function AlertsViewPickAssetsController(
  $uibModal,
  $timeout,
  $stateParams,
  $scope,
  $filter,
  configurationsService,
  equipmentRepository,
  gettextCatalog
) {
  'ngInject';

  $scope.animationsEnabled = true;
  $scope.equipmentByPage = [];
  $scope.equipments = []; //list of equipments to send to the database
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.filteredEquipmentList = [];
  $scope.loading = true;
  $scope.onLoadErrorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.postRemoval = [];
  $scope.removeFlags = {};
  $scope.removeLastAssetMsgFlag = false;
  $scope.removeLastAssetMsg = gettextCatalog.getString('You must have at least one Asset per Configuration.');
  $scope.removals = [];
  $scope.search = {
    text: ''
  };
  $scope.successFlag = false;

  var configurationId = $stateParams.configurationId;

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 15;
  $scope.maxSize = 1;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;
  var orderBy = $filter('orderBy');

  //Sort filteredEquipmentList
  $scope.orderEquipmentList = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
  };

  //applyFilter searchs the equipments[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredEquipmentList = $filter('filter')($scope.equipments, $scope.search.text);
  };

  $scope.initializeEquipments = function () {
    var existingIds = {
      criteria: {
        ids: []
      }
    };
    if ($scope.$parent.configuration) {
      $scope.equipments = $scope.$parent.configuration.equipment.data.slice();
    } else {
      $scope.equipments = $scope.equipmentData;
    }

    for (var i = 0; i < $scope.equipments.length; i++) {
      existingIds.criteria.ids.push($scope.equipments[i].id);
      $scope.removeFlags[$scope.equipments[i].id] = false;
    }
    if (existingIds.criteria.ids.length > 0) {
      equipmentRepository.postEquipmentListByIds(existingIds).then(
        function (response) {
          $scope.loading = false;
          $scope.equipments = response.data;
          $scope.postRemoval = $scope.equipments.slice();
          $scope.filteredEquipmentList = $scope.equipments.slice();
        },
        function (error) {
          var errorMsg = gettextCatalog.getString('Unable to retrieve Asset information');
          $scope.loading = false;
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
        }
      );
    } else {
      $scope.loading = false;
    }
  };

  function init() {
    //if edit configurations page is already loaded, the configuration and its resources will be available
    if ($scope.$parent.configuration) {
      $scope.initializeEquipments();
    } else {
      getConfigurationEquipmentData();
    }
  }

  init();

  function getConfigurationEquipmentData() {
    if (configurationId) {
      $scope.loading = true;
      configurationsService
        .getConfigurationById(configurationId)
        .then(function (response) {
          if (!response) {
            return;
          }

          $scope.equipmentData = [];
          for (var j = 0; j < response.data.equipment.data.length; j++) {
            $scope.equipmentData.push(response.data.equipment.data[j]);
          }
          $scope.initializeEquipments();
        })
        .catch(function (error) {
          var errorMsg = gettextCatalog.getString('An error occurred while retrieving configuration information.');
          $scope.errorText = errorMsg;
          $scope.errorFlag = true;
        })
        .finally(function () {
          $scope.loading = false;
        });
    } else {
      $scope.loading = false;
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = gettextCatalog.getString('Could not load page: no configuration Id provided.');
    }
  }

  //Asset Picker - Add/Remove equipment to/from configuration
  $scope.open = function (size) {
    var modalScope = $scope.$new();
    modalScope.modalTitle = 'Select Assets for Configuration: ' + $scope.$parent.configuration.name;

    $scope.resetFlags();
    var modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      template: require('../../../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      size: 'lg',
      scope: modalScope,
      resolve: {
        singleSelect: false,
        requiresSelection: true,
        maxSelection: function () {
          return 0;
        },
        selectedAssets: function () {
          var selected = {};

          if ($scope.equipments) {
            for (var i = 0; i < $scope.equipments.length; i++) {
              var e = $scope.equipments[i];
              selected[e.id] = e;
            }
          }
          return selected;
        }
      }
    });

    modalInstance.result.then(function (selectedAssets) {
      var changes = [];
      var changeResult = $scope.equipments.slice();
      for (var key in selectedAssets.result) {
        var alreadyPicked = false;
        for (var i = 0; i < $scope.equipments.length; i++) {
          if (key === $scope.equipments[i].id) {
            alreadyPicked = true;
            break;
          }
        }
        if (!alreadyPicked) {
          changeResult.push(selectedAssets.result[key]);
          $scope.applyChange({
            op: 'add',
            equipId: key
          }, changes);
        }
      }
      for (var i = 0; i < changeResult.length; i++) {
        var remove = true;
        for (var key in selectedAssets.result) {
          if (key === changeResult[i].id) {
            remove = false;
            break;
          }
        }
        if (remove) {
          $scope.applyChange({
            op: 'remove',
            equipId: changeResult[i].id
          }, changes);
          changeResult.splice(i, 1);
          i--;
        }
      }
      $scope.saveEquipments(changeResult, changes);
    });
  };

  $scope.toggleAnimation = function () {
    $scope.animationsEnabled = !$scope.animationsEnabled;
  };

  $scope.saveEquipments = function (newEquipmentList, changeset) {
    if (changeset.length == 0 || $scope.sending) {
      return;
    }
    if (newEquipmentList.length === 0 || $scope.equipments.length === newEquipmentList.length) {
      $scope.removeLastAssetMsgFlag = true;
      return;
    }
    $scope.errorFlag = false;
    var data = {
      changeset: changeset
    };
    $scope.sending = true;

    configurationsService.patchConfigurationEquipment($scope.$parent.configuration.id, data).then(
      function (response) {
        if (newEquipmentList) {
          $scope.equipments = newEquipmentList.slice();
        }
        $scope.$parent.configuration.equipment.data = $scope.equipments.slice();
        $scope.filteredEquipmentList = $scope.equipments.slice();
        $scope.checkRemovals();
        $scope.applyFilter();
        $scope.orderEquipmentList($scope.predicate, false);
        $scope.successFlag = true;
        $scope.sending = false;
        $timeout(function () {
          $scope.resetFlags();
        }, 2500);
      },
      function (error) {
        var errorMsg = gettextCatalog.getString('An error occurred while editing Assets');
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.sending = false;
      }
    );
    return true;
  };

  $scope.toggleRemoval = function (equip) {
    $scope.resetFlags();
    for (var i = 0; i < $scope.postRemoval.length; i++) {
      if ($scope.postRemoval[i].id === equip.id) {
        $scope.postRemoval.splice(i, 1);
        $scope.applyChange({
          op: 'remove',
          equipId: equip.id
        }, $scope.removals);
        return;
      }
    }
    //if we're toggling the checkbox off, put that equipment back into the post-removal list
    $scope.postRemoval.push(equip);
    $scope.applyChange({
      op: 'add',
      equipId: equip.id
    }, $scope.removals); //will cancel out the "remove" operation for that equip
  };

  $scope.checkRemovals = function () {
    for (var i = 0; i < $scope.equipments.length; i++) {
      //initialize checkbox models for new equipment
      var existed = false;
      for (var key in $scope.removeFlags) {
        if (key === $scope.equipments[i].id) {
          existed = true;
          break;
        }
      }
      if (!existed) {
        $scope.removeFlags[$scope.equipments[i].id] = false;
        $scope.postRemoval.push($scope.equipments[i]);
      }
    }
    $scope.removals = [];
    for (var key in $scope.removeFlags) {
      //clear checkbox models and changes (if necessary) for removed equipment
      var exists = false;
      for (var i = 0; i < $scope.equipments.length; i++) {
        if (key === $scope.equipments[i].id) {
          exists = true;
          break;
        }
      }
      if (!exists) {
        for (var i = 0; i < $scope.postRemoval.length; i++) {
          if ($scope.postRemoval[i].id === key) {
            $scope.postRemoval.splice(i, 1);
            break;
          }
        }
        delete $scope.removeFlags[key];
      }
      if ($scope.removeFlags[key]) {
        $scope.applyChange({
          op: 'remove',
          equipId: key
        }, $scope.removals);
      }
    }
  };

  $scope.applyChange = function (newChange, changeset) {
    $scope.resetFlags();
    for (var i = 0; i < changeset.length; i++) {
      //handle behaviour when multiple changes requested for same resource
      if (changeset[i].equipId && changeset[i].equipId === newChange.equipId) {
        if (changeset[i].op === newChange.op) {
          //only apply one add or remove per resource
          return;
        } else {
          //if ops are different, changes will cancel out (ie. adding and removing a resource in the same request will have no net effect)
          changeset.splice(i, 1);
          return;
        }
      }
    }
    changeset.push(newChange);
  };

  $scope.resetFlags = function () {
    $scope.errorFlag = false;
    $scope.successFlag = false;
    $scope.removeLastAssetMsgFlag = false;
  };
}